import {userConstants} from '../_constants';

export function contragentData(state = {}, action) {
  switch (action.type) {
    case userConstants.LOGIN_SUCCESS:
      return {};
    case userConstants.CONTRAGENT_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.CONTRAGENT_DATA_SUCCESS:
      return {
        ...action.data,
      };
    case userConstants.CONTRAGENT_DATA_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
